
import { createSlice } from "@reduxjs/toolkit";
import { getFacilityListApi } from "../configureStore";
export const facilityListSlice = createSlice({
    name: 'facilityList',
    initialState: {
        loading: false,
        facilities: [],
    },
    reducers:{
        setLoading: (state, action) => { 
            state.loading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(getFacilityListApi.endpoints.fetchFacilityListData.matchFulfilled, (state, action) => {
            state.loading = false
            state.facilities = [].concat(action.payload.facilities)
        })
    }
}
)
